import React, { useContext, useEffect, useState } from "react";
import { Stepper, Step } from "react-form-stepper";
import img from "./../../assets/provider-19.jpg";
import { Card } from "../ui/card";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { format } from "date-fns";
import {
  CalendarCheck,
  CalendarDays,
  CalendarIcon,
  Clock,
  CornerDownLeft,
  FileText,
  LocateFixed,
  MoveLeft,
  MoveRight,
} from "lucide-react";

import { cn } from "../lib/utils";
import { Button } from "../ui/button";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import success from "./../../assets/success.png";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../ui/breadcrumb";
import { Checkbox } from "../ui/checkbox";
import axios from "axios";
import { ApiContext } from "src/context/ApiContext.jsx";
import Invoice from "../Invoice";
import { toast, Toaster } from "sonner";

const steps = [
  "1 - Appointment",
  "2 - Address",
  "3 - Payment",
  "4 - Confirmation",
];

const Checkout = () => {
  const [offers, setOffers] = useState([]);
  const [bookingData, setBookingData] = useState(null);

  const [offerAmount, setOfferAmount] = useState(0);

  // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2N2I3MDhkYTNhZTdkMmUyNTdiNTdlY2QiLCJpYXQiOjE3NDA1NzM3NjAsImV4cCI6MTc0MTE3ODU2MH0.nMBaEm6kgrm9jwuveab8EdmFcHEIDbOU8dqUI_seNzI"
  const token = localStorage.getItem("token");
  const {
    subservice,
    setsubservice,
    setLastBookingData,
    fetchreview,
    setCheckoutSubServiceId,
    checkoutSubServiceId,
    Booking,
  } = useContext(ApiContext);
  const [searchParams] = useSearchParams();


  const SubServiceId = sessionStorage.getItem("subservice") || searchParams.get("subservice");
  // console.log(SubServiceId , "SubServiceId")
  const subService = subservice.find((service) => service._id === SubServiceId) || {};



  const [payamount, setPayAmount] = useState(subService?.price -
    subService?.price * (subService?.discount / 100));
  useEffect(() => {
    if (subService) {

      setPayAmount(subService?.price - subService?.price * (subService?.discount / 100));
    }
  }, [JSON.stringify(subService)]);
  console.log("payamount", payamount)
  const [activeStep, setActiveStep] = useState(0);
  const [user, setUser] = useState({});
  const handleNext = (activeStep) => {
    // console.log("activeStep" , activeStep)
    if ((activeStep === 0 && !selectedTime) || !date) {
      if (selectedTime !== "Book Instantly")
        return alert("Please Select Date and Time");
    }
    // console.log(selectAddress .address, "selectAddress")
    if (activeStep === 1 && !selectAddress.address) {
      return alert("Please Select Address");
    }
    // console.log("selectAddressselectAddressselectAddress : ", selectAddress);
    if (activeStep === 2) {
      const postBooking = async () => {
        // console.log("Booking Data : " , selectAddress , selectedTime , date)
        // console.log("Booking discount : ", offerAmount , ((subService.price - offerAmount)/subService.price ) * 100)

        const data = {
          subServiceId: SubServiceId,
          userId: user._id,
          paymentMode: "online",
          amount: offerAmount || subService?.price - subService?.price * (subService?.discount / 100),
          payamount: payamount,
          discount: ((subService.price - offerAmount) / subService.price) * 100,
          location: selectAddress,
          lat: selectAddress.lat,
          lng: selectAddress.lng,
          scheduledTime: selectedTime,
          currentBooking: date ? false : true,
          scheduledDate: date || new Date().setHours(0, 0, 0, 0),
        };

        const config = {
          url: "/api/user/bookings",
          method: "post",
          baseURL: "https://wavetechservices.in/",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: data,
        }

        const paymentConfig = {
          url: "/api/phonepay/addpaymentphonepay",
          method: "post",
          baseURL: "https://wavetechservices.in/",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: {
            userId: user._id,
            amount: payamount,
            username: user.name,
            orderId: SubServiceId + new Date(),

            Mobile: user.phone,
            config: JSON.stringify(config),
            failedUrl: "/checkout",
            successUrl: "/booking_list"
          },
        }

     

        try {
          const res = await axios(payamount > 0 ? paymentConfig : config);

          if (res.status === 200) {
            if (payamount > 0) {
              return window.location.href = res.data?.url?.url
            } else {
              toast.success("Booking Successful");
              setBookingData(res.data.booking);
              setLastBookingData(res.data.booking);
            }
          }



          // console.log("Booking successful:", res.data);
        } catch (err) {
          console.error("Error:", err);
        }
      };
      postBooking();

      // return alert("Please Select ")
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await axios.get("https://wavetechservices.in/api/user/profile", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(res.data.user);
      } catch (err) {
        console.error("Error : ", err);
      }
    };
    fetchUserData();
  }, []);

  console.log("user : ", user);


  useEffect(() => {
    const fetchOffer = async () => {
      const res = await axios.get("https://wavetechservices.in/api/user/offers");
      console.log("Res :", res.data.data);
      setOffers(res.data.data);
    };
    fetchOffer();
  }, []);

  const handleReset = () => {
    setActiveStep(0);
  };

  const [selectedTime, setSelectedTime] = useState("");
  const [date, setDate] = useState(null);

  const [selectAddress, setSelectAddress] = useState([]);
  // console.log(selectAddress , "selectAddress")

  const [address, setAddress] = useState({
    name: selectAddress.name,
    email: selectAddress.email,
    phone: selectAddress.phone,
    address: selectAddress.address,
  });

  const navigate = useNavigate();
  // console.log("offerAmount" , offerAmount)

  return (
    <div>
      <Stepper
        activeStep={activeStep}
        styleConfig={{
          activeBgColor: "green",
          completedBgColor: "green",
          inactiveBgColor: "gray",
          activeTextColor: "white",
          completedTextColor: "white",
          inactiveTextColor: "black",
        }}
      >
        {steps.map((label, index) => (
          <Step key={index} label={label} />
        ))}
      </Stepper>
      <div>
        {activeStep === 0 && (
          <ServiceInformation
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            date={date}
            setDate={setDate}
          />
        )}
        {activeStep === 1 && (
          <Address
            address={user}
            setSelectAddress={setSelectAddress}
            selectAddress={selectAddress}
            add={address}
          />
        )}
        {activeStep === 2 && (
          <Payment
            subService={subService}
            user={user}
            selectAddress={selectAddress}
            selectedTime={selectedTime}
            date={date}
            offers={offers}
            setOfferAmount={setOfferAmount}
            offerAmount={offerAmount}
            bookingAmount={subService?.price -
              subService?.price * (subService?.discount / 100)}
            setPayAmount={setPayAmount}
            payamount={payamount}

          />
        )}
        {activeStep === 3 && (
          <Confirmation
            date={date}
            selectedTime={selectedTime}
            booking={bookingData}
            payamount={payamount}
            subService={subService}
          />
        )}
        <div
          className="mb-10"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <Link to="/">
            <button
              className={`border border-black p-2 rounded-md px-5 hover:bg-black hover:text-white flex gap-1 font-semibold group mx-5 ${activeStep === 3 ? "block" : "hidden"
                }`}
            >
              {activeStep === 3 ? "Home" : ""}
            </button>
          </Link>
          <button
            // disabled={activeStep === 3}
            onClick={handleBack}
            style={{ marginRight: "10px" }}
            className={`border border-black p-2 rounded-md px-5 hover:bg-black hover:text-white flex gap-1 font-semibold group ${activeStep === 3 ? "hidden" : "block"
              }`}
          >
            <MoveLeft className="group-hover:scale-110" /> Back
          </button>
          <Link to={`${activeStep === 3 ? "/booking_list" : ""}`}>
            <button
              onClick={() => handleNext(activeStep)}
              className="border border-black p-2 rounded-md px-5 hover:opacity-80 flex gap-1 font-semibold gradient text-white group"
            >
              {activeStep === 0
                ? "Book Appointment"
                : activeStep === 2
                  ? "Proceed to Pay"
                  : activeStep === 3
                    ? "Booked History"
                    : "Next"}
              <MoveRight className="group-hover:scale-110" />
            </button>
          </Link>
        </div>
      </div>
      {/* {activeStep === steps.length && (
        <div>
          <p>All steps completed - you're finished</p>
          <button onClick={handleReset}>Reset</button>
        </div>
      )} */}
    </div>
  );
};

const ServiceInformation = ({
  selectedTime,
  setSelectedTime,
  date,
  setDate,
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(true);
  const handleSelectDate = (selectedDate) => {
    setDate(selectedDate);
    setIsPopoverOpen(false);
  };
  const times = [
    "9:00 AM",
    "9:30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "1:00 PM",
    "1:30 PM",
    "2:00 PM",
    "2:30 PM",
    "3:00 PM",
    "3:30 PM",
    "4:00 PM",
    "4:30 PM",
    "5:00 PM",
    "5:30 PM",
    "6:00 PM",
    "6:30 PM",
    "7:00 PM",
    "Book Instantly",
  ];
  const handleTimeSelect = (time) => {
    setSelectedTime(time);
  };
  return (
    <form className="px-[10vw] flex justify-between  gap-10 flex-col lg:flex-row">
      <div className="w-[30%]">
        <h1>Appointment Date</h1>
        <div className="my-5">
          <Popover
            open={isPopoverOpen}
            onOpenChange={setIsPopoverOpen}
            onClick={handleSelectDate}
          >
            <PopoverTrigger asChild>
              <Button
                variant={"outline"}
                className={cn(
                  "w-[280px] justify-start text-left font-normal",
                  !date && "text-muted-foreground"
                )}
              >
                <CalendarIcon />
                {date ? format(date, "PPP") : <span>Pick a date</span>}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0">
              <Calendar
                mode="single"
                selected={date}
                onSelect={setDate}
                initialFocus
                disabled={(date) =>
                  date < new Date(new Date().setHours(0, 0, 0, 0))
                } // ✅ Fix: Allow today's date
              />
            </PopoverContent>
          </Popover>
        </div>
      </div>
      <div className="lg:w-[70%] w-full">
        <h1>Appointment Time</h1>
        <Card className="my-3">
          <div>
            <label htmlFor="time-picker" className="px-6 my-4">
              Select a time:
            </label>
            <div className="flex gap-3 flex-wrap mx-auto px-6 my-1">
              {times.map((time, index) => (
                <div
                  key={index}
                  onClick={() => handleTimeSelect(time)}
                  className={`flex justify-center items-center border border-black p-1 mx-auto lg:mx-0 w-28 my-1 rounded-md cursor-pointer hover:bg-black hover:text-white ${selectedTime === time ? "bg-black text-white" : "bg-white"
                    //   ${time === 'Instant Time' ? "flex justify-center items-center border border-black p-1 mx-auto lg:mx-0 w-24 my-1 rounded-md cursor-pointer hover:bg-black hover:text-white " : "bg-white"
                    // }
                    }`}
                >
                  {time}
                </div>
              ))}
            </div>
            {/* <div className="p-5">
              <Button 
                className="border border-black p-2 rounded-md px-5 hover:opacity-80 flex gap-1 font-semibold gradient text-white group"
              >
                Book Instantly
              </Button>
            </div> */}
            {selectedTime && (
              <p className="px-6 my-4 ">
                Selected Time:{" "}
                <span className="font-semibold"> {selectedTime}</span>{" "}
              </p>
            )}
            {date && (
              <p className="px-6 my-4 ">
                Selected Date:{" "}
                <span className="font-semibold">
                  {date ? format(date, "PPP") : ""}
                </span>
              </p>
            )}
          </div>
        </Card>
      </div>
    </form>
  );
};

const Address = ({ address, setSelectAddress, selectAddress }) => {
  const handleSelectAddress = (add) => {
    if (add === null) {
      handleCurrentLocation();
      console.log("selected address", selectAddress);
      return;
    }
    console.log("selected address", add);
    setSelectAddress(add);
    console.log("add : ", add);
  };

  const handleCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser");
      return;
    }
    const GOOGLE_MAPS_API_KEY = "AIzaSyAHFoepvVjrlMUctcC4wn_VRpOznZBzmhA";

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
          );
          const data = await response.json();

          if (data.results && data.results[0]) {
            const address = data.results[0].formatted_address;

            setSelectAddress({
              address: address,
              landmark: "",
              addressType: "Current Location",
              lat: lat,
              lng: lng,
            });
            console.log("selectAddress : ", selectAddress);
          }
        } catch (error) {
          console.error("Geocoding error:", error);
          toast.error("Failed to get address from coordinates");
        }
      },
      (error) => {
        console.error("Geolocation error:", error);
        toast.error("Failed to get current location");
      }
    );
  };

  return (
    <div className="px-[10vw] flex justify-between  gap-10 flex-col lg:flex-row">
      <Toaster />
      <Card className="lg:w-[30%] p-3 h-[450px] overflow-y-auto w-full">
        <h1 className="my-5 text-center text-2xl">Select Address</h1>
        {address?.addresses?.map((add, index) => (
          <Card
            key={index}
            onClick={() => {
              handleSelectAddress(add);
            }}
            className={`p-3 my-3 hover:bg-black hover:text-white ${selectAddress._id === add._id ? "bg-black text-white" : ""
              }`}
          >
            <h1 className="font-semibold">{add.name}</h1>
            <p>{address.name}</p>
            <p>{address.email}</p>
            <p>{address.phone}</p>
            <p>Address Type : {add.addressType}</p>
            <p>{add.address}</p>
            <p>{add.landmark}</p>
          </Card>
        ))}
        {address?.addresses?.length === 0 ? (
          <div className="ml-5">Please Add address in Profile Section</div>
        ) : (
          <></>
        )}
      </Card>

      <Card className="lg:w-[70%] p-3 w-full">
        <h1 className="my-5 text-center text-2xl">Personal Information</h1>
        <form className="space-y-4">
          <div className="flex items-center">
            <div className="w-24 font-semibold">
              {" "}
              <label>Name: </label>
            </div>
            <input
              type="text"
              placeholder="Enter your Name"
              name="name"
              value={address.name}
              className="border border-gray-300 py-1 p-3 rounded-md w-96"
            />
          </div>
          <div className="flex items-center">
            <div className="w-24 font-semibold">
              <label className="w-40">Email: </label>
            </div>
            <input
              type="email"
              placeholder="Enter your Email"
              name="email"
              value={address.email}
              className="border border-gray-300 py-1 p-3 rounded-md w-96"
            />
          </div>
          <div className="flex items-center">
            <div className="w-24 font-semibold">
              <label className="w-40">Mobile No: </label>
            </div>
            <input
              type="number"
              placeholder="Enter your Mobile Number"
              min={10}
              max={10}
              name="phone"
              value={address.phone}
              className="border border-gray-300 py-1 p-3 rounded-md w-96"
            />
          </div>
          <div className="flex items-center">
            <div className="w-24 font-semibold">
              <label className="w-40">Address: </label>
            </div>
            {selectAddress.length !== 0 ? (
              <textarea
                cols="10"
                rows="5"
                name="address"
                value={` ${selectAddress.address}`}
                className="w-96 border border-300 rounded-md p-3"
              ></textarea>
            ) : (
              <textarea
                cols="10"
                rows="5"
                name="address"
                value=""
                className="w-96 border border-300 rounded-md p-3"
              ></textarea>
            )}
          </div>
          <div
            className="flex gap-3 items-center font-bold hover:underline cursor-pointer"
            // onClick={handleCurrentLocation}
            onClick={() => {
              handleSelectAddress(null);
            }}
          >
            <LocateFixed />
            Use Current Location
          </div>

          {/* <div className="flex items-center space-x-2">
            <Checkbox id="terms2" disabled />
            <label
              htmlFor="terms2"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Accept terms and conditions
            </label>
          </div> */}
          {/* <Checkbox/> */}
        </form>
      </Card>
    </div>
  );
};

const Payment = ({
  selectAddress,
  date,
  selectedTime,
  user,
  subService,
  offers,
  offerAmount,
  setOfferAmount,
  bookingAmount,
  setPayAmount,
  payamount
}) => {
  const handleCoupon = (offer) => {
    // setOfferAmount(0)
    const OfferAmount = subService?.price * (offer?.discount / 100);
    const AmountAfter1stOffer =
      subService?.price - subService?.price * (offer?.discount / 100);
    const totalOfferAmount =
      OfferAmount + AmountAfter1stOffer * (subService?.discount / 100);
    // console.log(OfferAmount , totalOfferAmount , "Totoal Offer Amount")
    setOfferAmount((prev) => subService?.price - totalOfferAmount);
    // setOfferAmount(subService.price - (subService.price * (offer.discount / 100)))
    setPayAmount(subService?.price - totalOfferAmount);

  };

  console.log("payamount", payamount)

  return (
    <div className="px-[10vw] flex justify-center items-center  gap-10">
      <Card className="lg:w-[50%] p-3 space-y-4 w-full ">
        <h1 className="my-5 text-center text-2xl underline">Booking Summary</h1>
        <div className="mb-3 flex items-center gap-10">
          <span className="flex items-center gap-3">
            <img
              src={`${subService?.icon[0]}`}
              alt=""
              className="aspect-square w-24 object-center rounded-md"
            />
          </span>
          <div>
            <div className="flex flex-row gap-2">
              <label>Service Name :</label>
              <h1 className="font-semibold">{subService?.name}</h1>
            </div>
            {/* <p>Price: ₹399</p> */}
            {/* <p>Service Provider: John Doe</p> */}
            {offerAmount ? (
              <p>
                Previous Amount :{" "}
                <span className="font-semibold text-xl line-through">
                  {" "}
                  ₹
                  {subService?.price -
                    subService?.price * (subService?.discount / 100)}
                </span>
              </p>
            ) : (
              <p>
                Amount to be paid:{" "}
                <span className="font-semibold text-xl">
                  {" "}
                  ₹
                  {subService?.price -
                    subService?.price * (subService?.discount / 100)}
                </span>
              </p>
            )}

            {offerAmount ? (
              <p>
                Amount to be paid:{" "}
                <span className="font-semibold text-xl"> ₹{offerAmount}</span>
              </p>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="space-y-1">
          <h3 className="font-normal text-lg my-2 underline">Booked Slot</h3>
          <p className="flex items-center gap-2">
            <CalendarCheck className="size-4" />{" "}
            <span className="font-semibold">
              {date ? format(date, "PPP") : ""}
            </span>
          </p>
          <p className="flex items-center gap-2">
            <Clock className="size-4" />{" "}
            <span className="font-semibold">{selectedTime}</span>
          </p>
        </div>
        <div className="space-y-1">
          <h3 className="font-normal text-lg my-2 underline">
            Booking Information
          </h3>
          <p>
            Name : <span className="font-semibold">{user?.name}</span>
          </p>
          <p>
            Contact Number :{" "}
            <span className="font-semibold">{user?.phone}</span>
          </p>
          <p>
            Email : <span className="font-semibold">{user?.email}</span>
          </p>
          <p>
            Address :{" "}
            <span className="font-semibold">
              {selectAddress?.address}
              {" , "}
              {selectAddress?.landmark}
            </span>
          </p>
          <hr />
          <div className="mt-4 flex flex-col sm:flex-row gap-4 text-sm font-medium">
            {/* Minimum Amount Option */}
            <label
              htmlFor="amount"
              className={`flex items-center gap-2 px-4 py-2 border rounded-lg cursor-pointer transition-all
                ${payamount === (offerAmount || bookingAmount) * 0.25
                  ? 'bg-red-100 border-red-500 text-red-700'
                  : 'bg-white hover:bg-gray-50 border-gray-300'
                }`}
            >
              <input
                type="radio"
                id="amount"
                name="amount"
                value="Minimum Amount"
                className="accent-red-600"
                onChange={() =>
                  setPayAmount((offerAmount || bookingAmount) * 0.25)
                }
                checked={payamount === (offerAmount || bookingAmount) * 0.25}
              />
              ₹{((offerAmount || bookingAmount) * 0.25).toFixed(2)} Minimum Amount
            </label>

            {/* Full Amount Option */}
            <label
              htmlFor="full"
              className={`flex items-center gap-2 px-4 py-2 border rounded-lg cursor-pointer transition-all
                ${payamount === (offerAmount || bookingAmount)
                  ? 'bg-red-100 border-red-500 text-red-700'
                  : 'bg-white hover:bg-gray-50 border-gray-300'
                }`}
            >
              <input
                type="radio"
                id="full"
                name="amount"
                value="Full Amount"
                className="accent-red-600"
                onChange={() => setPayAmount(offerAmount || bookingAmount)}
                checked={payamount === (offerAmount || bookingAmount)}
              />
              ₹{(offerAmount || bookingAmount).toFixed(2)} Full Amount
            </label>
          </div>


        </div>

      </Card>
      <Card className="w-[40%] p-3 ">
        {/* <h1 className="my-5 text-center text-2xl underline">Payment </h1> */}
        <div className="max-w-md w-full flex flex-col gap-4 bg-white p-6 rounded-lg shadow-sm">
          <h1 className="font-bold text-center text-xl mb-2">Offers & Benefits</h1>

          <div className="flex flex-col gap-4">
            <p className="text-sm font-medium text-gray-700">Available Offers</p>

            {offers
              .filter((offer) => {
                const currentDate = new Date();
                const offerEndDate = new Date(offer.endDate);
                return offerEndDate > currentDate;
              })
              .map((offer) => (
                <div
                  className="border border-gray-100 rounded-lg p-4 hover:shadow-sm transition-all"
                  key={offer._id}
                >
                  <div className="flex justify-between items-start mb-2">
                    <div className="flex items-center gap-2">
                      <span className="font-bold text-lg">{offer?.couponCode}</span>
                      <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded">
                        {offer?.discount}% OFF
                      </span>
                    </div>
                    <button
                      className="text-gradient font-semibold hover:text-blue-800 transition-colors"
                      onClick={() => handleCoupon(offer)}
                    >
                      APPLY
                    </button>
                  </div>

                  <p className="text-sm text-gray-600 mb-2">{offer?.offerTitle}</p>

                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-3 w-3"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span>Valid until: {new Date(offer.endDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric'
                    })}</span>
                  </div>
                </div>
              ))}

            {offers.filter(offer => new Date(offer.endDate) > new Date()).length === 0 && (
              <div className="text-center py-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10 mx-auto text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p className="text-gray-500 mt-2">No current offers available</p>
              </div>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

const Confirmation = ({ selectedTime, booking ,payamount,subService}) => {
  console.log("subService" , subService)
  const date = new Date();
  const day = date.getDate();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  //make an api which gives you the latest booking
  // const { Booking } = useContext(ApiContext);

  const month = monthNames[date.getMonth()];
  const year = date.getFullYear(); // Function to get the ordinal suffix for the day
  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // covers 11th to 19th
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };
  const formattedDate = `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
  const [invoice, setInvoice] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Success confirmation */}
      <div className="text-center mb-10">
        <div className="flex flex-col items-center justify-center space-y-4">
          <img
            src={success}
            alt="Success"
            className="w-24 h-24 object-contain"
          />
          <h1 className="text-2xl font-bold text-green-600">
            {payamount > 0 ? "Payment Proccessing" : "Your booking was successful!"}
      
          </h1>
          <p className="text-gray-500">
            We've sent the booking details to your email
          </p>
        </div>
      </div>

      {/* Booking details card */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
        <div className="p-6 md:p-8">
          <div className="flex flex-col justify-between gap-8">
            {/* Left section - Booking info */}
            <div className="flex-1">
              <div className="flex items-start gap-4 mb-6">
                <img
                  src={`${subService?.icon[0]}`}
                  alt="Service"
                  className="w-16 h-16 object-contain rounded-lg bg-gray-50 p-2 border border-gray-200"
                // onError={(e) => {
                //   e.target.src = "https://via.placeholder.com/64?text=Service";
                // }}
                />
                <div>
                  <h2 className="text-xl font-bold text-gray-800">
                    {subService?.name}
                  </h2>
                  {booking && (
                  <p className="text-gray-500 text-sm mt-1">
                    
                    Booking ID: {booking?._id}
                  </p>)}
                </div>
              </div>
                {booking && ( <div className="space-y-4">
                <h3 className="font-semibold text-lg text-gray-800 border-b pb-2">
                  Booking Details
                </h3>
                <div className="flex items-center gap-3">
                  <CalendarCheck className="h-5 w-5 text-blue-500" />
                  <div>
                    <p className="text-sm text-gray-500">Date</p>
                    <p className="font-medium">
                      {new Date(booking?.scheduledDate).toLocaleDateString('en-US', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Clock className="h-5 w-5 text-blue-500" />
                  <div>
                    <p className="text-sm text-gray-500">Time</p>
                    <p className="font-medium">{booking?.scheduledTime}</p>
                  </div>
                </div>
                <div className="pt-4">
                  <p className="text-sm text-gray-500">Location</p>
                  <p className="font-medium">
                    {booking?.location?.address || "Not specified"}
                  </p>
                  {booking?.location?.landmark && (
                    <p className="text-sm text-gray-500 mt-1">
                      Near {booking.location.landmark}
                    </p>
                  )}
                </div>
              </div>)}
             
            </div>

            {/* Right section - Invoice */}
            { booking && (<div className="w-full flex flex-col items-center">
              {showInvoice ? (
                <div className="w-full">
                  <Invoice booking={booking} />
                </div>
              ) : (
                <Button
                  onClick={() => setShowInvoice(true)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg flex items-center gap-2"
                >
                  <FileText className="h-4 w-4" />
                  View Invoice
                </Button>
              )}
            </div>)}
            
          </div>
        </div>
      </div>

      {/* Additional help section */}
      <div className="mt-8 text-center text-sm text-gray-500">
        <p>Need help with your booking?</p>
        <p className="mt-1">
          Contact us at{" "}
          <a href="mailto:support@example.com" className="text-blue-600 hover:underline">
            info@wavetechservice.in
          </a>{" "}
          or call +91 9900006581
        </p>
      </div>
    </div>
  );
};

export default Checkout;
